import React from 'react';
import Navbar from '../components/Navigation/Navbar';
import SciFiBackground from '../components/SciFiBackground/SciFiBackground';
import RecoveryWallet from '../components/Wallet/RecoveryWallet';

const RecoveryWalletPage = () => {
  return (
    <SciFiBackground>
      <div className="min-h-screen">
        <Navbar />
        <RecoveryWallet />
      </div>
    </SciFiBackground>
  );
};

export default RecoveryWalletPage;
